import { action, observable } from "mobx";
import { persist } from "mobx-persist";
import {
  MainDatabaseRef,
  PublicDataDatabaseRef,
  UkaiDatabaseRef,
  firebase,
  firebaseApp,
} from "../config/firebase";

class AppState {
  @persist @observable authenticated = false;
  @observable authenticating = false;

  @persist("object") @observable user = {};
  @persist("object") @observable userFirebase = {};

  @observable dataDomisili = [];
  @observable dataPendidikanApoteker = [];

  @observable programs = {};
  @observable invoices = {};
  @observable invoiceData = {};

  @persist("object") @observable md = {};
  @persist("object") @observable md1 = {};

  @persist("object") @observable qmid = {};

  @persist @observable notificationToken = "";

  @observable serverTimeOffset = 0;
  hasListenUser = false;

  @action logout() {
    if (this.userFirebase.uid) {
      MainDatabaseRef.child("users")
        .child(this.userFirebase.uid)
        .off();
    }

    return firebaseApp
      .auth()
      .signOut()
      .then(
        () => {
          this.resetData();
        },
        (error) => console.log(error)
      );
  }

  baseURL = "https://us-central1-obat-ukai.cloudfunctions.net/api";

  @action resetData() {
    this.authenticated = false;
    this.authenticating = false;

    this.notificationToken = "";

    this.user = {};
    this.userFirebase = {};

    this.programs = {};
    this.invoices = {};
    this.invoiceData = {};

    this.md = {};
  }

  @action getFirebaseIdToken() {
    // console.log('🔍 getFirebaseIdToken called');
    // console.log('🔍 authenticated:', this.authenticated);
    // console.log('🔍 userFirebase:', this.userFirebase);

    let firebaseUser = firebaseApp.auth().currentUser;

    if (firebaseUser) {
      console.log('🔍 Getting token from current user');
      return firebaseUser.getIdToken().then((token) => {
        console.log('🔍 Token received from current user:', token ? 'YES' : 'NO');
        return Promise.resolve(token);
      }).catch((error) => {
        console.error('❌ Error getting token from current user:', error);
        return Promise.reject(error);
      });
    } else {
      console.log('🔍 No current user, checking auth state');
      return new Promise((resolve, reject) => {
        const unsubscribe = firebaseApp.auth().onAuthStateChanged((user) => {
          unsubscribe(); // Unsubscribe after first call

          if (user) {
            console.log('🔍 User found in auth state, getting token');
            user.getIdToken().then((token) => {
              console.log('🔍 Token received from auth state:', token ? 'YES' : 'NO');
              resolve(token);
            }).catch((error) => {
              console.error('❌ Error getting token from auth state:', error);
              reject(error);
            });
          } else {
            console.log('❌ No user in auth state');
            this.resetData();
            reject(new Error('No user authenticated'));
          }
        });
      });
    }
  }

  @action setQMID(packid, qid, qdata) {
    let newData = Object.assign({}, this.qmid);
    if (!newData[packid]) {
      newData[packid] = {};
    }

    newData[packid][qid] = qdata;

    this.qmid = newData;
  }

  @action registerFirebase({ email, password, name, hp }) {
    this.authenticating = true;

    return firebaseApp
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((userCredential) => {
        amplitude.setUserId(userCredential.user.uid);
        amplitude.logEvent("Register Success", {
          userCredential: JSON.stringify(userCredential),
        });

        this.userFirebase = userCredential.user;
        this.authenticating = false;
        this.authenticated = true;

        if (name) {
          this.updateUser("name", name);
        }
        // if(hp){this.updateUser('hp', hp)}

        // this.registerOBATio({
        //   name: name,
        //   hp: hp,
        // })

        return this.loadAndListenUser();
      });
  }

  @action registerOBATio({ name, hp, verificationMethod }) {
    // console.log(this.getFirebaseIdToken())

    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          name: name,
          hp: hp,
          verificationMethod: verificationMethod,
          source: "ukai",
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Register Ukai");

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/main_api/register",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          // console.log(isSuccess)
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve(responseJson);
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action verifyOBATioOTP({ code }) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          code: code,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Register Ukai");

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/main_api/otp_check",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            // $('#confirmationModal').modal('hide');

            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action forgetPassword(email) {
    this.authenticating = true;

    return firebaseApp
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        this.authenticating = false;
        swal("Cek email kamu ya");
      })
      .catch((error) => {
        this.authenticating = false;
        swal("Ups..", "Gagal mengirimkan: " + error.message, "error");
      });
  }

  @action signInWithEmailAndPassword(email, password) {
    this.authenticating = true;

    return firebaseApp
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((userCredential) => {
        this.userFirebase = userCredential.user;
        this.authenticating = false;
        this.authenticated = true;
        return this.loadAndListenUser();
      });
  }

  @action userListenAndAuth(userCredential) {
    this.userFirebase = userCredential.user;
    this.authenticating = false;
    this.authenticated = true;
    return this.loadAndListenUser();
  }

  @action signInWithToken(token) {
    this.authenticating = true;

    // alert("we3");
    return firebaseApp
      .auth()
      .signInWithCustomToken(token)
      .then((userCredential) => {
        this.userFirebase = userCredential.user;
        this.authenticating = false;
        this.authenticated = true;
        return this.loadAndListenUser();
      });
    // .catch(function(error) {
    //   // Handle Errors here.
    //   var errorCode = error.code;
    //   var errorMessage = error.message;

    //   // this.userFirebase = userCredential.user;
    //   // this.authenticating = false;
    //   // this.authenticated = true;
    //   // ...
    //   console.log
    // });

    // return firebaseApp.auth().signInWithEmailAndPassword(email, password)
    // .then((userCredential) => {
    //   this.userFirebase = userCredential.user;
    //   this.authenticating = false;
    //   this.authenticated = true;
    //   return this.loadAndListenUser();
    // })
  }

  @action checkAuth() {
    // let user = firebaseApp.auth().currentUser;

    // if (user) {
    //   this.userFirebase = user;
    //   amplitude.setUserId(user.uid);
    //   amplitude.logEvent('Check Auth Success', {userFirebase: JSON.stringify(user)});
    //   this.authenticating = false;
    //   this.authenticated = true;
    //   return this.loadAndListenUser();
    // }
    // else {
    //   this.authenticating = false;
    //   this.authenticated = false;
    // }

    let _unsubscribe = firebaseApp.auth().onAuthStateChanged((user) => {
      // this.userFirebase = {uid: 'anBP0CwziEOw9UcGK1MUhllTAur2'};

      if (user) {
        this.userFirebase = user.toJSON();
        amplitude.setUserId(user.uid);
        amplitude.logEvent("Check Auth Success", {
          userFirebase: JSON.stringify(user),
        });
        this.authenticating = false;
        this.authenticated = true;
        return this.loadAndListenUser();
      } else {
        this.authenticating = false;
        this.authenticated = false;
      }
      _unsubscribe();
    });
  }

  @action loadAndListenUser() {
    // console.log("panggil")
    let promises = [this.loadUserData()];

    return Promise.all(promises);
  }

  @action loadUserData() {
    if (!this.userFirebase.uid) {
      return Promise.resolve();
    }

    return MainDatabaseRef.child("users")
      .child(this.userFirebase.uid)
      .once("value")
      .then((snapshot) => {
        let user = snapshot.val();

        amplitude.setUserId(user.uid);
        amplitude.logEvent("Load user data", { user: JSON.stringify(user) });
        amplitude.setUserProperties(user);

        this.user = user;

        setTimeout(() => {
          this.listenUserData();
        }, 3000);
      });
  }

  @action listenUserData() {
    if (!this.userFirebase.uid) {
      return Promise.resolve();
    }

    MainDatabaseRef.child("users")
      .child(this.userFirebase.uid)
      .on("value", (snapshot) => {
        let data = snapshot.val();
        this.user = data;
      });

    // if(this.hasListenUser){
    //   return
    // }
    // this.hasListenUser =  true;

    // let promise1 = MainDatabaseRef.child('users').child(this.userFirebase.uid).on('child_added', (snapshot)=>{
    //   let data = snapshot.val();
    //   let key = snapshot.key;

    //   let newUser = Object.assign({}, this.user)
    //   newUser[key] = newUser

    //   if(newUser[key]){
    //     // console.log("udah ada")
    //   } else {
    //     this.user = newUser
    //   }
    // })

    // let promise2 = MainDatabaseRef.child('users').child(this.userFirebase.uid).on('child_changed', (snapshot)=>{
    //   let data = snapshot.val();
    //   let key = snapshot.key;
    //   // console.log(key)
    //   // console.log(data)
    //   let newUser = Object.assign({}, this.user)
    //   newUser[key] = newUser

    //   // amplitude.logEvent('Listen user data', {user: user});

    //   this.user = newUser
    // })

    // let promise3 = MainDatabaseRef.child('users').child(this.userFirebase.uid).on('child_removed', (snapshot)=>{
    //   let data = snapshot.val();
    //   let key = snapshot.key;

    //   let newUser = Object.assign({}, this.user)
    //   delete newUser[key]

    //   // amplitude.logEvent('Listen user data', {user: user});

    //   this.user = newUser
    // })

    // return Promise.all([promise2,promise3])
  }

  @action updateUser(property, value, noDelay = false) {
    return MainDatabaseRef.child("users")
      .child(this.userFirebase.uid)
      .child(property)
      .set(value);
  }

  @action updateConfirmation(invoiceKey, property, value) {
    return MainDatabaseRef.child("invoices")
      .child(invoiceKey)
      .child("confirmation")
      .child(property)
      .set(value);
  }

  @action handleRegisterNext() {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Register Next");

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/registernext",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action handleChooseProgram(pid, voucher_code = "") {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          pid: pid,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Choose program", { pid: pid });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/registerchooseprogram",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action handleCheckout(obj) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          referral_code: obj.referral_code,
          payment_method: obj.payment_method,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Register Checkout");

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/registercheckout",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action handleConfirmPayment(invoiceKey) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          invoiceKey: invoiceKey,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Confirm Payment", { invoiceKey: invoiceKey });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/registerconfirmpayment",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action loadPrograms() {
    return UkaiDatabaseRef.child("programs")
      .orderByChild("isActive")
      .startAt(true)
      .endAt(true)
      .once("value")
      .then((snapshot) => {
        let programs = snapshot.val();

        this.programs = programs;

        amplitude.logEvent("Load Programs", {
          programs: JSON.stringify(programs),
        });

        return Promise.resolve(programs);
      });
  }

  @action loadProgram(pid) {
    return UkaiDatabaseRef.child("programs")
      .child(pid)
      .once("value")
      .then((snapshot) => {
        return Promise.resolve(snapshot.val());
      });
  }

  @action loadInvoices() {
    return MainDatabaseRef.child("user-invoices")
      .child(this.userFirebase.uid)
      .once("value")
      .then((snapshot) => {
        let invoices = snapshot.val();

        this.invoices = invoices;

        amplitude.logEvent("Load Invoices", {
          invoices: JSON.stringify(invoices),
        });

        return this.listenInvoiceData();
      });
  }

  @action listenInvoiceData() {
    let arrPromises = [];

    if (!this.invoices) {
      return;
    }

    for (var i = 0; i < Object.keys(this.invoices).length; i++) {
      let invoiceKey = Object.keys(this.invoices)[i];

      let loaderInvoice = MainDatabaseRef.child("invoices")
        .child(invoiceKey)
        .once("value")
        .then((snapshot) => {
          let invoice = snapshot.val();

          let newInvoice = Object.assign({}, this.invoiceData);
          newInvoice[invoiceKey] = invoice;

          this.invoiceData = newInvoice;
        });

      let listenerInvoice = MainDatabaseRef.child("invoices")
        .child(invoiceKey)
        .on("value", (snapshot) => {
          let invoice = snapshot.val();

          let newInvoice = Object.assign({}, this.invoiceData);
          newInvoice[invoiceKey] = invoice;

          this.invoiceData = newInvoice;
        });

      arrPromises.push(loaderInvoice);
      arrPromises.push(listenerInvoice);
    }

    return Promise.all(arrPromises);
  }

  @action handleConfirmUserForTreasurer(iid, type) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          iid: iid,
          type: type,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Confirm User for Treasurer", { iid: iid });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/Treasurer/confirminvoice",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action handleStartExam(packid) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          packid: packid,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Start Exam", { packid: packid });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/startexam",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action handleFinishExam(packid) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          packid: packid,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Finish Exam", { packid: packid });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/finishexam",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action handleNgoreksi(packid) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          packid: packid,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Ngoreksi Exam", { packid: packid });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/ngoreksi",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            // swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action handleResetExam(packid) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          packid: packid,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Start Exam", { packid: packid });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/resetexam",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action addMentorToProgramGroup(mentor_uid, pid, gid) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          mentor_uid: mentor_uid,
          pid: pid,
          gid: gid,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Add Mentor", {
        msg: `add mentor ${mentor_uid} to program ${pid} group ${gid}`,
      });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_apiSuperMentor/addmentor",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action removeMentorFromProgramGroup(mentor_uid, pid, gid) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          mentor_uid: mentor_uid,
          pid: pid,
          gid: gid,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Remove Mentor", {
        msg: `remove mentor ${mentor_uid} from program ${pid} group ${gid}`,
      });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_apiSuperMentor/removementor",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action addStudentToProgramGroup(student_uid, pid, gid) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          student_uid: student_uid,
          pid: pid,
          gid: gid,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Add Student", {
        msg: `add student ${student_uid} to program ${pid} group ${gid}`,
      });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_apiSuperMentor/addstudent",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action handleUnbannedStudent(student_uid) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          student_uid: student_uid,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Unbanned Student", {
        msg: `unbanned student ${student_uid}`,
      });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/Treasurer/unbannedStudent",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action removeStudentFromProgramGroup(student_uid, pid, gid) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          student_uid: student_uid,
          pid: pid,
          gid: gid,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Remove Student", {
        msg: `remove student ${student_uid} from program ${pid} group ${gid}`,
      });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_apiSuperMentor/removestudent",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action removeGroupFromProgram(pid, gid) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          pid: pid,
          gid: gid,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Remove Group", {
        msg: `Remove group ${gid} from program ${pid}`,
      });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_apiSuperMentor/removegroup",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action editEventsGroupFromProgram(pid, gid, events) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          pid: pid,
          gid: gid,
          events: events,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Update Group Events", {
        msg: `update events group ${gid} from program ${pid}`,
      });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_apiSuperMentor/editEvents",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action removePackage(packid) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          packid: packid,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Remove Package", { msg: "Remove package:" + packid });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_apiSuperMentor/removepackage",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action optOutFreeTrial() {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Opt Out Free Trial");

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/optoutfreetrial",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action chooseProgram() {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Programs", { message: "add more program" });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/chooseprogram",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            amplitude.logEvent("Programs", {
              message: "success add more program",
            });
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action optInProgram(pid) {
    amplitude.logEvent("Programs", { message: "opt in program: " + pid });
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          pid: pid,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/optinprogram",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            amplitude.logEvent("Programs", {
              message: "success opt in program: " + pid,
            });
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action handleAcceptAgreement() {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Send Accept Agreement");

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/acceptagreement",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            amplitude.logEvent("Agreement", { message: "accept agreement " });
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action setServerTimeOffset(data) {
    this.serverTimeOffset = data || 0;
  }

  @action loadDataDomisili() {
    PublicDataDatabaseRef.child("data-domisili")
      .once("value")
      .then((snapshot) => {
        let dataDomisili = snapshot.val();
        this.dataDomisili = dataDomisili;
      });
  }

  @action loadPendidikanApoteker() {
    PublicDataDatabaseRef.child("data-pendidikan-apoteker")
      .once("value")
      .then((snapshot) => {
        let dataPendidikanApoteker = snapshot.val();
        this.dataPendidikanApoteker = dataPendidikanApoteker.sort();
      });
  }

  @action getVoucherData(voucher_code, pass) {
    let data = {
      method: "POST",
      credentials: "omit",
      mode: "cors",
      body: JSON.stringify({
        code: voucher_code,
        pass: pass,
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    let isSuccess = false;

    amplitude.logEvent("voucher", { code: voucher_code });

    return fetch(
      "https://us-central1-obat-io.cloudfunctions.net/ukai_apiPublicUkai/voucher_checker",
      data
    )
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          isSuccess = true;
        } else {
          isSuccess = false;
        }

        return response.text().then((responseText) => {
          try {
            const responseJson = JSON.parse(responseText);
            return responseJson;
          } catch (err) {
            isSuccess = false;
            // return responseText
            return Promise.reject({ message: responseText });
          }
        });
      })
      .then((responseJson) => {
        if (isSuccess) {
          // swal(responseJson.message)
          // swal("Sukses..", responseJson, "success");
          return Promise.resolve(responseJson);
        } else {
          // swal("Ups..",responseJson.message, "error")
          return Promise.reject(responseJson);
        }
      })
      .catch((e) => {
        swal("Ups..", e.message, "error");
        return Promise.reject();
      });
  }

  @action createVoucher({
    name,
    email,
    domisili,
    whatsapp,
    bank_account,
    bank_name_holder,
    referral_code,
  }) {
    let data = {
      method: "POST",
      credentials: "omit",
      mode: "cors",
      body: JSON.stringify({
        name: name,
        email: email,
        domisili: domisili,
        whatsapp: whatsapp,
        bank_account: bank_account,
        bank_name_holder: bank_name_holder,
        referral_code: referral_code,
      }),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    let isSuccess = false;

    amplitude.logEvent("voucher", {
      msg: {
        name,
        email,
        domisili,
        whatsapp,
        bank_account,
        bank_name_holder,
        referral_code,
      },
    });

    return fetch(
      "https://us-central1-obat-io.cloudfunctions.net/ukai_apiPublicUkai/create_voucher",
      data
    )
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          isSuccess = true;
        } else {
          isSuccess = false;
        }

        return response.text().then((responseText) => {
          try {
            const responseJson = JSON.parse(responseText);
            return responseJson;
          } catch (err) {
            isSuccess = false;
            // return responseText
            return Promise.reject({ message: responseText });
          }
        });
      })
      .then((responseJson) => {
        if (isSuccess) {
          // swal(responseJson.message)
          // swal("Sukses..", responseJson, "success");
          return Promise.resolve(responseJson);
        } else {
          // swal("Ups..",responseJson.message, "error")
          return Promise.reject(responseJson);
        }
      })
      .catch((e) => {
        swal("Ups..", e.message, "error");
        return Promise.reject();
      });
  }

  @action checkoutMidtrans(iid) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          iid: iid,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Load Token", { iid: iid });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/checkout_midtrans",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              isSuccess = true;
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            return Promise.resolve(responseJson);
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action handleLoadVideoApi(video_code) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          video_code: video_code,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      amplitude.logEvent("Load Video", { video_code: video_code });

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_api/Video/getVideoOTP",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              isSuccess = true;
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            return Promise.resolve(responseJson);
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }

  @action async askForPermissioToReceiveNotifications() {
    try {
      const messaging = firebase.messaging();
      await messaging.requestPermission();
      const token = await messaging.getToken();

      firebase
        .database()
        .ref("user-token")
        .child(this.userFirebase.uid)
        .child(token)
        .set(true);

      this.notificationToken = token;

      return token;
    } catch (error) {
      if (error.code === "messaging/permission-blocked") {
        // swal("Ups..","Notifikasi diblokir oleh browser kamu.", "error");
      }
      this.notificationToken = "";
      console.error(error);
    }
  }

  @action updateExamSearch(packid) {
    return this.getFirebaseIdToken().then((token) => {
      let data = {
        method: "POST",
        credentials: "omit",
        mode: "cors",
        body: JSON.stringify({
          packid: packid,
        }),
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      let isSuccess = false;

      return fetch(
        "https://us-central1-obat-io.cloudfunctions.net/ukai_apiSuperMentor/examUpdateSearch",
        data
      )
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            isSuccess = true;
          } else {
            isSuccess = false;
          }

          return response.text().then((responseText) => {
            try {
              const responseJson = JSON.parse(responseText);
              return responseJson;
            } catch (err) {
              isSuccess = false;
              // return responseText
              return Promise.reject({ message: responseText });
            }
          });
        })
        .then((responseJson) => {
          if (isSuccess) {
            // swal(responseJson.message)
            swal("Sukses..", responseJson.message, "success");
            return Promise.resolve();
          } else {
            // swal("Ups..",responseJson.message, "error")
            return Promise.reject(responseJson);
          }
        })
        .catch((e) => {
          swal("Ups..", e.message, "error");
          return Promise.reject();
        });
    });
  }
}

export default AppState;
